import { Linear } from '@kaltura-ott/tvpil-shared';

import { useHandleClickInfoButton } from '../useHandleClickInfoButton/useHandleClickInfoButton';
import { useInitializationHook } from '../useInitializationHook/useInitializationHook';
import { useMuteHook } from '../useMuteHook/useMuteHook';
import { useResolveConditionsVideoPlayout } from '../useResolveConditionsVideoPlayout/useResolveConditionsVideoPlayout';
import { useTimeRange } from '../useTimeRange/useTimeRange';
import { useWatchNowHandler } from '../useWatchNowHandler/useWatchNowHandler';

function useVideoPlayoutCombiner() {
  const { muted, muteHandler } = useMuteHook();
  const {
    currentAsset,
    isContentBlockedAsAdult,
    program,
    assetId,
    programTitle,
    parentalRating,
    logoImages,
    programName,
    isPlayerCondition,
    isContentRestricted,
    isContentGeoBlocking,
    isLinear,
    isLinearWithoutCurrentProgram,
    isImagesCondition,
    isNoProgramCondition,
    isImagesErrorCondition,
    isMosaicProgram,
    setChannelLogoErrorForward,
  } = useResolveConditionsVideoPlayout();
  const { playableAsset, loaded } = useInitializationHook(isPlayerCondition);
  const watchNowHandler = useWatchNowHandler({
    isContentBlockedAsAdult,
    program,
    assetId,
    parentalRating,
    playableAsset: playableAsset as Linear, // Cast playableAsset to Linear type
  });
  const handleClickInfoButton = useHandleClickInfoButton(currentAsset);
  const { timeRange } = useTimeRange(program);

  return {
    muted,
    loaded,
    program,
    programTitle,
    programName,
    playableAsset,
    currentAsset,
    logoImages,
    timeRange,
    isLinear,
    isPlayerCondition,
    isContentRestricted,
    isContentGeoBlocking,
    isImagesCondition,
    isMosaicProgram,
    isContentBlockedAsAdult,
    isNoProgramCondition,
    isImagesErrorCondition,
    isLinearWithoutCurrentProgram,
    muteHandler,
    watchNowHandler,
    handleClickInfoButton,
    setChannelLogoErrorForward,
  };
}

export { useVideoPlayoutCombiner };
